import React from 'react';

// Build-time injection from .github/workflows/deploy*.yml.
// Empty in local dev — component renders nothing.
const SHA = process.env.REACT_APP_VERSION_SHA || '';
const PR = process.env.REACT_APP_VERSION_PR || '';
const REPO = process.env.REACT_APP_VERSION_REPO || '';
const SHORT_SHA = SHA.slice(0, 7);

export default function VersionBadge() {
  if (!SHA && !PR) return null;

  // Prefer linking to the PR when we have one; fall back to the commit.
  const href = PR && REPO
    ? `https://github.com/${REPO}/pull/${PR}`
    : (SHA && REPO ? `https://github.com/${REPO}/commit/${SHA}` : null);

  const label = PR ? `PR #${PR}` : SHORT_SHA;
  const tooltip = PR ? `PR #${PR} · ${SHORT_SHA}` : SHORT_SHA;

  const style = {
    position: 'fixed',
    bottom: 8,
    right: 12,
    zIndex: 9999,
    fontSize: 10,
    letterSpacing: '0.06em',
    color: '#444466',
    textDecoration: 'none',
    fontFamily: 'monospace',
    background: 'rgba(30, 30, 35, 0.7)',
    padding: '2px 6px',
    borderRadius: 3,
    pointerEvents: 'auto',
  };

  if (!href) {
    return <span title={tooltip} style={style}>{label}</span>;
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" title={tooltip} style={style}>
      {label}
    </a>
  );
}
